module.exports = __webpack_public_path__ + "img/c361744.png";